export default __webpack_public_path__ + "static/media/thumbnail3.4b762549.png";